import {
    faCalendarXmark,
    faMoneyBill,
    faMoneyBillTransfer,
    faArrowsRotate,
    faCalendar,
    faScrewdriverWrench,
    faFileInvoiceDollar,
    faListCheck,
    faCircleInfo
} from '@fortawesome/free-solid-svg-icons'; // Certifique-se de usar a biblioteca colorreta de ícones

export const COMMITMENT_TYPES = {
    1: { title: 'Vencimento', color: '#dc3545', icon: faCalendarXmark },
    2: { title: 'Pagamento', color: '#ffc107', icon: faMoneyBill },
    3: { title: 'Recebimento', color: '#28a745', icon: faMoneyBillTransfer },
    4: { title: 'Renovação', color: '#17a2b8', icon: faArrowsRotate },
    5: { title: 'Reunião', color: '#3788d8', icon: faCalendar },
    6: { title: 'Manutenção', color: '#fd7e14', icon: faScrewdriverWrench },
    7: { title: 'Imposto', color: '#d63384', icon: faFileInvoiceDollar },
    8: { title: 'Tarefa', color: '#6c757d', icon: faListCheck },
    9: { title: 'Outro', color: '#495057', icon: faCircleInfo }
};